export enum EHFeatureFlags {
    RequirementLevel = '20220909_AN-22774_REQUIREMENT_LEVEL',
    LDScopedClAssignmentChanges = 'AN-21797_SCOPED_CL_ASSIGNMENT_CHANGES',
    DocumentAnalysisEmailNotification = 'document-analysis-email-notification'
}
